import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    success: false,
    socials: [],
};

const socialsSlice = createSlice({
    name: 'socials',
    initialState,
    reducers: {
        setSocials: (state, action) => {
            state.socials = action.payload;
        },
    },
});

export const socialsReducer = socialsSlice.reducer;
export const { setSocials } = socialsSlice.actions;
